import { installWebApiBridge } from "./installApiBridge";
import { mountWebApp } from "./app";
import { loadAgenticFeatureFlag } from "@shared/ui/agenticFeatures";
import { loadOwnLedgerFeatures } from "@shared/ui/ownLedgerFeatures";

installWebApiBridge();

const host = document.getElementById("app");
if (!host) {
  throw new Error("#app mount point missing");
}

void Promise.all([loadAgenticFeatureFlag(), loadOwnLedgerFeatures()]).then(() => {
  mountWebApp(host);
});
